import authCheckApp from './authCheckApp'

/**
 * 使手机单次震动
 * @since 1.0.0
 * @example
 * 
 * singleShake()
 */
function singleShake() {
    authCheckApp()
        .then(() => {
        // 发起请求
            window.WebViewJavascriptBridge.callHandler('singleShake', {}, (response) => {
                return response
            })
        })
}

export default singleShake